// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1TBGp","title":"ClientCherryInfo_title__220aq","itemText":"ClientCherryInfo_itemText__3RRDz"};